import {
  Field,
  ModalContainer,
  ModalHeader,
  ModalStyle,
  ContentField,
  ContentToken,
  ContentButtons,
  TextTimer,
  TextLabel,
  FormContainerModal,
  SelectTypeValidation,
  FormRadio,
  FormRadioContent,
} from './styles';
import { MdClose, MdLocalPhone } from 'react-icons/md';
import { FiMail } from 'react-icons/fi';
import TextField from 'components/layout/form/textField';
import OutlinedButton from 'components/layout/form/outlinedButton';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Formik } from 'formik';
import * as Yup from "yup";
import { cellPhoneNumberRegex } from 'utils/regex';
import { toggleMembershipStep, registerValuesMembership } from 'store/actions/membership-actions';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import api from 'services/api';
import axios from 'axios';

const formatTimer = (timer) => {
  let minutes = parseInt(timer / 60, 10);
  let seconds = parseInt(timer % 60, 10);
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return minutes + ":" + seconds;
}

const Modal = ({ dispatch, show, handleCloseModal, ...props }) => {
  const [step, setStep] = useState('validationOption');
  const [validationType, setValidationType] = useState('');
  const [validationValue, setValidationValue] = useState('');
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectTypeValidation, setSelectTypeValidation] = useState("email");

  const intervalRef = useRef();
  let newTimer = 60;

  const decreaseNum = () => {
    if (newTimer === 0) {
      setStartTimer(false);
      clearInterval(intervalRef.current);
      return;
    }
    setTimer((prev) => {
      newTimer = newTimer - 1;
      return prev - 1;
    })
  };

  useEffect(() => {
    if (startTimer) {
      intervalRef.current = setInterval(decreaseNum, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [startTimer]);

  const requestGetAccessToken = useCallback(async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
        baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      grant_type: "client_credentials",
    };

    let access_token = "";

    try {
      const response = await req.post("oauth/access-token", body, parameters);
      access_token = response.data.access_token
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }

    return access_token;
  }, []);

  const sendToken = async (type, value) => {
    const access_token = await requestGetAccessToken();
    const headers = {
      access_token,
    };

    const bodyToken = {
      contactType: type,
      contact: value
    };

    const responseToken = await api.post(`industrial/customer/v1/customers/tokens`, bodyToken, {
      headers,
    });

    if (responseToken.status === 201) {
      toast.warn(`Enviamos um código de verificação para ${value}`);
      return responseToken;
    } else {
      toast.error("Ocorreu um erro interno na aplicação");
      return false;
    }
  }

  const validationToken = async (token, value) => {
    const access_token = await requestGetAccessToken();
    const headers = {
      access_token,
    };

    const bodyToken = {
      token: token,
      contact: value
    };

    let success;
    try {
      await api.post(`industrial/customer/v1/customers/validations`, bodyToken, {
        headers,
      });
      success = true;
    } catch (error) {
      toast.error(error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação");
      success = false;
    }

    return success;
  }

  const handleSave = async (data) => {
    const objectFormmated = {}
    if (validationType === 'EMAIL') {
      objectFormmated.email = validationValue;
      objectFormmated.emailToken = data.token;
    }
    if (validationType === 'PHONE') {
      const phoneDdd = validationValue.slice(0, 2);
      const phoneNumber = validationValue.slice(2);

      objectFormmated.phoneNumber = phoneNumber;
      objectFormmated.phoneDdd = phoneDdd;
      objectFormmated.phoneToken = data.token;
    }
    await dispatch(registerValuesMembership(objectFormmated));
  }

  const handlerSubmitToken = async (data) => {
    setLoading(true);
    const response = await validationToken(data.token, validationValue);

    if (response) {
      await handleSave(data);
      await dispatch(toggleMembershipStep(3));
    }
    setLoading(false);
  }

  const handlerSubmitEmail = async (data) => {
    setLoading(true);
    await sendToken('EMAIL', data.email);
    setStep('validationToken');
    setValidationType('EMAIL');
    setValidationValue(data.email);
    setStartTimer(true);
    setLoading(false);
  }

  const handlerSubmitPhone = async (data) => {
    setLoading(true);
    const value = data.phoneNumber.replace(/[^\d]/g, "");
    await sendToken('PHONE', value);
    setStep('validationToken');
    setValidationType('PHONE');
    setValidationValue(value);
    setStartTimer(true);
    setLoading(false);
  }

  const resetStep = () => {
    setStep('validationOption');
    setStartTimer(false);
    setTimer(60);
  }

  const resendToken = async () => {
    setLoading(true);
    setTimer(60);
    setStartTimer(true);
    await sendToken(validationType, validationValue);
    setLoading(false);
  }

  const onHide = () => {
    handleCloseModal();
    resetStep();
  }

  const validatorSchemaEmail = () => Yup.object().shape({
    email: Yup.string().email("E-mail inválido").required("É necessário um e-mail"),
  });

  const validatorSchemaToken = () => Yup.object().shape({
    token: Yup.string().required("É necessário um token"),
  });

  const validatorSchemaPhone = () => Yup.object().shape({
    phoneNumber: Yup.string().required("É necessário digitar seu número de celular").test(
      "Telefone",
      "Número de telefone inválido",
      value => {
        if (value) {
          value = value.replace(/[^\d]/g, "");
          return !!value.match(cellPhoneNumberRegex)
        }
        return null
      }
    ),
  });

  return (
    <ModalStyle
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalContainer>
        <ModalHeader>
          <div>
            <div>
              <h2>Dados cadastrais</h2>
              <span>Valide pelo <b>menos um de seus contatos</b> pessoaisasd</span>
            </div>
            <MdClose size={24} onClick={handleCloseModal} />
          </div>
        </ModalHeader>

        {step === 'validationOption' && (
          <div>
            <SelectTypeValidation>
              <FormRadioContent>
                <FormRadio
                  custom
                  type="radio"
                  id="email"
                  name="type"
                  label="Email"
                  isSelect={selectTypeValidation === "email"}
                  onClick={() => setSelectTypeValidation("email")}
                />
                <FormRadio
                  custom
                  type="radio"
                  id="phone"
                  name="type"
                  label="Celular"
                  isSelect={selectTypeValidation === "phone"}
                  onClick={() => setSelectTypeValidation("phone")}
                />
              </FormRadioContent>
            </SelectTypeValidation>
            {selectTypeValidation === "email" && (
              <Formik
                initialValues={{
                  email: '',
                }}
                onSubmit={handlerSubmitEmail}
                validationSchema={validatorSchemaEmail}
                render={({
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => (
                  <FormContainerModal>
                    <span>Um código será enviado no email informado</span>
                    <ContentField>
                      <Field>
                        <TextField
                          LeadingIcon={() => <FiMail size={24} />}
                          type="text"
                          name="email"
                          label="Email *"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          errorCondition={errors.email && touched.email}
                          errorMessage={errors.email}
                          disabled={loading}
                        />
                      </Field>
                      <OutlinedButton
                        type="submit"
                        disabled={!values.email || errors.email || loading}
                      >
                        Validar email
                      </OutlinedButton>
                    </ContentField>
                  </FormContainerModal>
                )}
              />
            )}
            {selectTypeValidation === "phone" && (
              <Formik
                initialValues={{
                  phoneNumber: '',
                }}
                onSubmit={handlerSubmitPhone}
                validationSchema={validatorSchemaPhone}
                render={({
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => (
                  <FormContainerModal>
                    <span>Um código será enviado no celular informado</span>
                    <ContentField>
                      <Field>
                        <TextField
                          LeadingIcon={() => <MdLocalPhone size={24} />}
                          name="phoneNumber"
                          mask="(99) 9 9999-9999"
                          label="Celular com DDD *"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phoneNumber}
                          errorCondition={errors.phoneNumber && touched.phoneNumber}
                          errorMessage={errors.phoneNumber}
                          disabled={loading}
                        />
                      </Field>
                      <OutlinedButton
                        type="submit"
                        disabled={!values.phoneNumber || errors.phoneNumber || loading}
                      >
                        SMS
                      </OutlinedButton>
                    </ContentField>
                  </FormContainerModal>
                )}
              />
            )}
          </div>
        )}
        {step === 'validationToken' && (
          <ContentToken>
            <TextLabel>
              {validationType === 'EMAIL' && 'O código foi enviado para o email informado'}
              {validationType === 'PHONE' && 'O código foi enviado por SMS'}
            </TextLabel>
            <Formik
              initialValues={{
                token: '',
              }}
              onSubmit={handlerSubmitToken}
              validationSchema={validatorSchemaToken}
              render={({
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
              }) => (
                <FormContainerModal>
                  <Field>
                    <TextField
                      name="token"
                      label="Inserir código *"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.token}
                      errorCondition={errors.token && touched.token}
                      errorMessage={errors.token}
                      disabled={loading}
                    />
                  </Field>
                  <TextTimer>Não recebi o código. {timer > 0 ? `Aguarde ${formatTimer(timer)}` : <a href="#" onClick={resendToken}>Enviar novamente</a>}</TextTimer>
                  <ContentButtons id="content-buttons">
                    <OutlinedButton
                      disabled={!values.token || errors.token || loading}
                      type="submit"
                    >
                      Validar código
                    </OutlinedButton>
                    {timer <= 0 && (
                      <OutlinedButton
                        onClick={resetStep}
                        disabled={loading}
                      >
                        Trocar forma de validação
                      </OutlinedButton>
                    )}
                  </ContentButtons>
                </FormContainerModal>
              )}
            />
          </ContentToken>
        )}
      </ModalContainer>
    </ModalStyle>
  )
}

const mapStateToProps = state => ({
  name: state.membershipReducer.name,
  document: state.membershipReducer.document,
  phoneDdd: state.membershipReducer.phoneDdd,
  phoneNumber: state.membershipReducer.phoneNumber,
  email: state.membershipReducer.email,
  emailToken: state.membershipReducer.emailToken,
  birthdate: state.membershipReducer.birthdate,
  unit: state.membershipReducer.unit,
  address: state.membershipReducer.address,
  nameCompletedSerasa: state.membershipReducer.nameCompletedSerasa,
  blockIdSf: state.membershipReducer.blockIdSf,
  condominiumIdSf: state.membershipReducer.condominiumIdSf,
  organizationId: state.membershipReducer.organizationId
});

export default connect(mapStateToProps)(Modal);
